var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"introudct-wrapper"},[_c('banner'),_c('summarys'),_c('tech'),(_vm.show)?_c('core'):_vm._e(),_c('honor')],1)}
var staticRenderFns = []

export { render, staticRenderFns }